/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const LostWeightIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M50 44.7V5.3C50 1.7 48.3 0 44.7 0H5.4C1.7 0 0 1.7 0 5.3v40.8c.4 2.5 2.7 4.3 5.2 3.9h39.4c.2 0 .5.1.7.1.2 0 .5 0 .7-.1 2.6-.5 4.3-2.8 4-5.3zm-26.3 1.2c0 .6-.1.9-.2 1.1-.2.2-.5.2-1 .2H5.2c-2 0-2.3-.4-2.3-2.3V5c0-1.9.4-2.3 2.4-2.3h39.9c1.8 0 2.3.4 2.3 2.2V45c0 1.7-.4 2.2-2 2.2H27.2c-.2 0-.5-.1-.7-.1V18.6h-2.7v8.5c-.1 6.2-.2 12.6-.1 18.8z' />
			<path d='M36.6 13.3V5.1c0-.5-.9-1-1.3-1H14.8c-.5 0-1.3.6-1.3 1.1-.1 2.7-.1 5.4 0 8.2v2.5h23.2l-.1-2.6zm-2.7-1.1c0 .5 0 .8-.2.9-.2.2-.4.2-.9.2H17.1c-.4 0-.7-.1-.8-.2-.1-.1-.2-.4-.2-.7.1-1.4.1-2.9 0-4.8 0-.4 0-.6.2-.7.1-.1.4-.2.7-.2h16c.4 0 .6.1.7.2.1.1.2.4.2.8v4.5z' />
		</svg>
	)
}

export default LostWeightIcon
